var watchlistSelector = {
	label: "Seleccionar lista de seguimiento",
	validationErrors: {
		selectWatchlist: "Debes selecionar una lista de seguimiento"
	}
};
var es = {
	watchlistSelector: watchlistSelector
};

export { es as default, watchlistSelector };
